<div class="page-padding">
  <div class="panel">
    <div class="panel__header" *ngIf="UCSetupType==1 || newOrExistingOption==2">
      <span class="panel__header__title">{{translate('Equipment Setup')}} </span>
    </div>
    <div class="panel__header" *ngIf="UCSetupType!=1 && newOrExistingOption==1" style="display: flex;flex-direction: row;justify-content: start;">
      <span class="panel__header__title">{{translate('Equipment Setup - Basic')}} </span>
      <span style="margin-left: 1%;" >{{translate('Should you require more fields for your equipment, please navigate to your user preferences and select         "Standard" for your Undercarriage Setup')}} </span>
    </div>
    <div class="panel__content center-content" *ngIf="setupComplete" [@fadeInOut]>
      <div class="setup-complete-container">
        <div class="setup-complete__header">{{'Setup Complete!' | translate | async}} </div>
        <i class="material-icons large-check">check_circle</i>
        <div class="set-complete__sub-header">{{'Now that you have setup your equipment, you need to setup the undercarriage for it before you can start recording inspections.' | translate | async}}</div>
        <div  *ngIf="UCSetupType!=1 && isRSH ==true" class="set-complete__sub-header" style="font-weight: bold; font-size:16px ;margin-top: 7%;" >{{'To Add or Update Undercarriage Components for Rope Shovels and Hydraulic Shovels, please update your user Preferences to Advanced.' | translate | async}}</div>
          <div class="button-container">
              <button mat-raised-button color="warn" (click)="navigateToSetupUndercarriage()">{{'Setup Undercarriage for This Equipment' | translate | async}}</button>
              <button mat-raised-button *ngIf="unsyncedId > 0" (click)="navigateToUnsyncedInspection()">{{'Unsynced Inspection' | translate | async}}</button>
              <button mat-raised-button (click)="navigateToSetupNewEquipment()">{{'Setup Another Equipment' | translate | async}}</button>
          </div>
      </div>
    </div>
    <mat-horizontal-stepper *ngIf="!setupComplete" [linear]="true" [selectedIndex]="currentStep" #stepper>
      <mat-step>
        <ng-template matStepLabel>{{'Select Customer & Job Site' | translate | async}}</ng-template>
        <div class="step-container">
          <div class="margin-b--16">
            <b>{{ translate('Would you like to setup a new equipment or modify an existing one?') }}</b>
          </div>
          <div class="margin-bottom-24">
            <mat-radio-group [(ngModel)]="newOrExistingOption" ngDefaultControl>
              <mat-radio-button [value]="1" (click)="onNewEquipment()">{{translate('Setup New Equipment')}}</mat-radio-button>
              <mat-radio-button [value]="2" (click)="onSelectEquipment()">{{translate('Modify Existing Equipment')}}</mat-radio-button>
            </mat-radio-group>
            <div *ngIf="newOrExistingOption == 2" class="existing-info" [@fadeInOut] style="margin-top: 8px;">
              {{ translate('You can only change the SMU/Hourmeter, LTD and Date of an existing equipment if there have been NO inspections performed, or actions recorded. If you need to record that a component has been changed, you should record an action against that equipment. ')}}
            </div>
          </div>
          <div class="input-group-description" *ngIf="newOrExistingOption == 1" [@fadeInOut]>
            {{translate('Please select the customer and job site where this equipment is located.')}}
          </div>
          <div class="input-group-description" *ngIf="newOrExistingOption == 2" [@fadeInOut]>
            <b>{{translate('Please select the equipment.')}}</b>
          </div>
            <div class="margin-bottom-24">
                <!-- <mat-form-field>
                    <mat-select placeholder="{{'Customer' | translate | async}}" [(ngModel)]="selectedCustomer" (selectionChange)="loadJobsitesForCustomer()" ngDefaultControl required>
                        <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
                            {{customer.Name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->
                <mat-form-field>
                  <input type="text" placeholder="{{'Customer' | translate | async}}" matInput [(ngModel)]="customerName" (input)="changedCustomer($event)"
                  [matAutocomplete]="customerAuto" required>
                    <mat-autocomplete #customerAuto="matAutocomplete" (optionSelected)="onCustomerSelected($event.option)">
                      <mat-option *ngFor="let customer of customerList" [value]="customer.Name">
                        {{customer.Name}}
                      </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <!-- <mat-form-field>
                    <mat-select placeholder="{{'Job Site' | translate | async}}" [(ngModel)]="selectedJobsite" (selectionChange)="loadEquipmentForJobsite()" ngDefaultControl required>
                        <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
                            {{jobsite.Name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->
                <mat-form-field>
                  <input type="text" placeholder="{{'Job Site' | translate | async}}" matInput [(ngModel)]="jobsiteName" (input)="changedJobsite($event)"
                  [matAutocomplete]="jobsiteAuto" required>
                    <mat-autocomplete #jobsiteAuto="matAutocomplete" (optionSelected)="onJobsiteSelected($event.option)">
                      <mat-option *ngFor="let jobsite of jobsiteList" [value]="jobsite.Name">
                        {{jobsite.Name}}
                      </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
  
                <mat-form-field [hidden]="newOrExistingOption == 1" [@fadeInOut]>
                    <mat-select placeholder="{{'Serial / Unit Number' | translate | async}}" [(ngModel)]="selectedEquipment" ngDefaultControl required (selectionChange)="onSelectEquipment()">
                        <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                            {{equipment.SerialNumber}} : {{equipment.UnitNumber}} 
                            <small *ngIf="equipment.AddiUnitNumber!=null"> | {{ equipment.AddiUnitNumber }} </small>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
  
                <a class="button" (click)="openAddNewJobsite()">
                    <i class="material-icons button__icon">add_location</i>
                    <span class="button__text">{{'Add Job Site' | translate | async}}</span>
                </a>
            </div>
          <div>
            <span class="red-text" *ngIf="newOrExistingOption==2 && InspectionCount>=2">{{'This equipment has more than 2 inspections associated with it. You cannot modify equipment details after this point. Please contact support if you need to make changes.' | translate | async}}</span>
            <button *ngIf="InspectionCount<=2" mat-raised-button color="warn" (click)="goToStep(1)" [disabled]="loadingExistingEquipment" [class.loading]="loadingExistingEquipment">{{'Next' | translate | async}}</button>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{'Equipment Details' | translate | async}}</ng-template>
        <div class="step-container">
          <div class="margin-bottom-24">
            <div class="input-group-description">{{'How do you identify this equipment?' | translate | async}}</div>
            <mat-form-field>
              <input matInput placeholder="{{'Serial Number' | translate | async}}" type="text" style="height: 35px;"
                     [ngStyle]="{'background-color':( UCSetupType !== 1) && ( serialNumber =='') ? '#FF5353' : 'transparent'}" [(ngModel)]="serialNumber" [ngClass]="{'red-background': UCSetupType !== 1}" (blur)="validateSerialAndUnit()" ngDefaultControl required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="{{'Unit Number' | translate | async}}" type="text" [(ngModel)]="unitNumber" style="height: 35px;"
                     [ngStyle]="{'background-color':( UCSetupType !== 1) && ( unitNumber =='') ? '#FF5353' : 'transparent'}" (blur)="validateSerialAndUnit()" ngDefaultControl required>
            </mat-form-field>
  
            <mat-form-field *ngIf="UCSetupType==1">
              <input matInput placeholder="{{'Additional Unit Number' | translate | async}}" type="text" [(ngModel)]="additionalUnitNo" ngDefaultControl>
            </mat-form-field>
            <!-- <div class="red" *ngIf="!serialUnitValid">{{'This equipment serial number and unit number combination is taken. You must enter a unique combination. ' | translate | async}}</div> -->
            <div class="red" *ngIf="!serialUnitValid">{{'A machine with this Serial No and Unit No combination already exists in your Dealer Group. Please contact your Dealer group administrator to be given access to this machine' | translate | async}}</div>
          </div>
          <div class="margin-bottom-24">
            <div class="input-group-description">{{'What type of equipment is this?' | translate | async}}</div>
            <!-- <mat-form-field>
              <mat-select placeholder="{{'Make' | translate | async}}" [(ngModel)]="selectedMake" (selectionChange)="loadModelsForMake()" ngDefaultControl required>
                <mat-option [value]="make.Id" *ngFor="let make of makeList">
                  {{make.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field> -->

            <mat-form-field>
                  <input type="text" placeholder="{{'Make' | translate | async}}" matInput [(ngModel)]="makeName" (input)="changedMake($event)"
                  [matAutocomplete]="makeAuto" required>
                    <mat-autocomplete #makeAuto="matAutocomplete" (optionSelected)="onMakeSelected($event.option)">
                      <mat-option *ngFor="let make of makeList" [value]="make.Name">
                        {{make.Name}}
                      </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

            <!-- <mat-form-field>
        <mat-select placeholder="{{'Model' | translate | async}}" [(ngModel)]="selectedModel" (selectionChange)="loadFamilyNameForModel()" ngDefaultControl required>
          <mat-option [value]="model.Id" *ngFor="let model of modelList">
            {{model.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
  
  
            <mat-form-field>
              <input type="text" placeholder="{{'Model' | translate | async}}" (input)="changedModel($event)" matInput required
                     [matAutocomplete]="auto" [(ngModel)]="machineModel">
              <mat-autocomplete [(ngModel)]="modelTitle" #model_auto="ngModel" #auto="matAutocomplete" required ngDefaultControl
                                (optionSelected)="onSelcetionModel($event.option)" (selectionChange)="loadFamilyNameForModel()">
                <mat-option [value]="model.Name" *ngFor="let model of modelList ">
                  {{model.Name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
  
  
            {{familyName}}
            <button *ngIf="newOrExistingOption=='1'" style="margin-left:20px;" color="warn" mat-raised-button (click)="requestANewModelPopup()">{{'Request New Model' | translate | async}}</button>
          </div>
          <div class="margin-bottom-24" *ngIf="UCSetupType==1 || newOrExistingOption=='2'">
            <div class="input-group-description">{{'What is the earliest known SMU/Hourmeter and the date of reading for this equipment?' | translate | async}}</div>
            <mat-form-field>
              <input matInput placeholder="{{'SMU/Hourmeter at Setup' | translate | async}}" type="number" [(ngModel)]="smuAtSetup" (blur)="validateSmuAndLtd()" ngDefaultControl required [disabled]="!canChangeHoursAndDate">
              <span matSuffix>Hours</span>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="{{'LTD at Setup' | translate | async}}" matTooltipClass="ltd-tooltip" matTooltip="LTD is the 'Life To Date' of the equipment. &#13;&#13;This will generally be the same as the SMU/Hour Meter reading. &#13;&#13;If the meter has been changed, LTD shows the actual machine hours where the SMU/Hour Meter will only show the hours since the meter was installed." type="number" [(ngModel)]="ltdAtSetup" (blur)="validateSmuAndLtd()" ngDefaultControl required [disabled]="!canChangeHoursAndDate">
              <span matSuffix>Hours</span>
            </mat-form-field>
            <mat-form-field *ngIf="isRSH">
              <input matInput placeholder="{{'PMU at Setup' | translate | async}}" (blur)="validateSmuAndPmu()" matTooltipClass="ltd-tooltip" matTooltip="PMU is the 'Propel Hours' of the equipment." type="number" [(ngModel)]="pmuAtSetup" ngDefaultControl required>
              <span matSuffix>Hours</span>
            </mat-form-field>
            <mat-form-field (click)="canChangeHoursAndDate ? picker.open() : null">
              <input matInput [matDatepicker]="picker" max="{{todate | date:'yyyy-MM-dd'}}" placeholder="{{'Date of Reading' | translate | async}}" [(ngModel)]="dateOfReading" [disabled]="!canChangeHoursAndDate" [formControl]="dateOfReadingControl">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <div class="red" *ngIf="!smuLtdGreaterThanZero">{{'The meter reading (SMU/Hourmeter) and life to date (LTD) must be greater than 0. ' | translate | async}}</div>
            <div class="red" *ngIf="!ltdGreaterThanSmu">{{'The life to date (LTD) of the equipment cannot be less than the SMU/Hourmeter. ' | translate | async}}</div>
            <div class="red" *ngIf="!pmuGreaterThanZero">{{'The Propel Hours must be greater than 0. ' | translate | async}}</div>
            <div class="red" *ngIf="!pmuGreaterThanZero">{{'The Propel Hours must be greater than 0. ' | translate | async}}</div>
            <div class="red" *ngIf="!smuGreaterThanPmu">{{'The meter reading (SMU/Hourmeter) of the equipment cannot be less than the Propel Hours. ' | translate | async}}</div>
  
          </div>
          <div class="margin-bottom-24 row-content" *ngIf="showDistTravelledTracking">
            <mat-checkbox class="margin-right-16" [(ngModel)]="enableDistTravelledTracking" ngDefaultControl></mat-checkbox>
            <b>{{'Enable Tracking by Distance Travelled' | translate | async}}</b>
          </div>
          <div class="margin-bottom-24" *ngIf="showDistTravelledTracking && enableDistTravelledTracking">
              <div class="input-group-description">{{'What is the earliest known forward and reverse distance on this equipment?' | translate | async}}</div>
              <mat-form-field>
                <input matInput placeholder="{{'Forward Distance on Equipment (Km)' | translate | async}}" type="number" [(ngModel)]="distanceForwardatSetup" ngDefaultControl>
                <span matSuffix>Km</span>
              </mat-form-field>
              <mat-form-field>
                <input matInput placeholder="{{'Reverse Distance on Equipment (Km)' | translate | async}}" type="number" [(ngModel)]="distanceReverseatSetup" ngDefaultControl>
                <span matSuffix>Km</span>
              </mat-form-field>
          </div>
          <div class="margin-bottom-24" *ngIf="UCSetupType==1 || newOrExistingOption == '2'">
  
            <mat-form-field>
              <input matInput placeholder="{{'BCM at Setup' | translate | async}}" type="number" [(ngModel)]="bcmAtSetup" ngDefaultControl>
              <span matSuffix>m³</span>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="{{'Tonnage at Setup' | translate | async}}" type="number" [(ngModel)]="tonAtSetup" ngDefaultControl>
              <span matSuffix>Tons</span>
            </mat-form-field>
          </div>
  
          <div class="margin-bottom-24">
            <div class="input-group-description">{{'You can attach a photo of this equipment which can be seen throughout the application.' | translate | async}}</div>
            <input type='file' (change)="onSelectEquipmentPhoto($event)">
            <div style="margin-top: 8px;">
              <img *ngIf="imageUrl" [src]="imageUrl" height="300">
            </div>
          </div>
          <div>
            <button mat-raised-button (click)="goBackStep()">{{'Back' | translate | async}}</button>
            <button *ngIf="UCSetupType==1 || newOrExistingOption=='2'" mat-raised-button color="warn" (click)="goToStep(2)" [disabled]="!smuLtdGreaterThanZero || !ltdGreaterThanSmu || !pmuGreaterThanZero || !smuGreaterThanPmu">{{'Next' | translate | async}}</button>
  
  
  
            <button mat-raised-button *ngIf="UCSetupType!=1 &&  newOrExistingOption=='1'" [disabled]="creatingEquipment" [class.loading]="creatingEquipment" (click)="onCreateNewEquipmentClick_UCSYSTEMBasic()" color="warn">{{'Create Equipment' | translate | async}}</button>
          </div>
        </div>
  </mat-step>
      <mat-step *ngIf="UCSetupType==1 || newOrExistingOption=='2'">
        <ng-template matStepLabel>{{'Additional Information' | translate | async}}</ng-template>
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'On average how many days is this equipment in use, and on which days?' | translate | async}}</div>
          <mat-form-field>
            <input matInput value="0" type="number" min="0" max="24" [(ngModel)]="hoursUsePerDay" ngDefaultControl required>
            <span matSuffix>{{'Hours per Day' | translate | async}}</span>
          </mat-form-field>
          <mat-checkbox class="margin-right-16" [(ngModel)]="monCheck" ngDefaultControl>{{'Mon' | translate | async}}</mat-checkbox>
          <mat-checkbox class="margin-right-16" [(ngModel)]="tueCheck" ngDefaultControl>{{'Tue' | translate | async}}</mat-checkbox>
          <mat-checkbox class="margin-right-16" [(ngModel)]="wedCheck" ngDefaultControl>{{'Wed' | translate | async}}</mat-checkbox>
          <mat-checkbox class="margin-right-16" [(ngModel)]="thuCheck" ngDefaultControl>{{'Thu' | translate | async}}</mat-checkbox>
          <mat-checkbox class="margin-right-16" [(ngModel)]="friCheck" ngDefaultControl>{{'Fri' | translate | async}}</mat-checkbox>
          <mat-checkbox class="margin-right-16" [(ngModel)]="satCheck" ngDefaultControl>{{'Sat' | translate | async}}</mat-checkbox>
          <mat-checkbox [(ngModel)]="sunCheck" ngDefaultControl>{{'Sun' | translate | async}}</mat-checkbox>
        </div>
         <mat-form-field>
            <input matInput value="0" type="number" [(ngModel)]="AvgDistance" ngDefaultControl required>
            <span matSuffix>{{'Usage Distance' | translate | async}} ({{userUOD}}) {{'per day' | translate | async}}</span>
        </mat-form-field>
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'How often will you be inspecting this equipment? We will use this to help forecast future inspections.' | translate | async}}</div>
          <mat-form-field>
            <input matInput placeholder="{{'I will inspect every' | translate | async}}" type="number" [(ngModel)]="inspectEvery" ngDefaultControl required>
          </mat-form-field>
          <mat-form-field>
            <mat-select [(ngModel)]="selectedInspectEveryUnit" ngDefaultControl required>
              <mat-option [value]="unit.Id" *ngFor="let unit of unitList">
                {{unit.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'You can also set some aditional details, although this is not required.' | translate | async}}</div>
          <div>
            <mat-form-field>
              <mat-select placeholder="{{'Application' | translate | async}}" [(ngModel)]="selectedApplication" ngDefaultControl>
                <mat-option [value]="application.Id" *ngFor="let application of applicationList">
                  {{application.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-select placeholder="{{'Ranking' | translate | async}}" [(ngModel)]="selectedRanking" ngDefaultControl>
                <mat-option [value]="ranking.Id" *ngFor="let ranking of rankingList">
                  {{ranking.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-select placeholder="{{'Machine Status' | translate | async}}" [(ngModel)]="selectedStatus" ngDefaultControl>
                <mat-option [value]="status.Id" *ngFor="let status of statusList">
                  {{ status.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!--TT-6884-->
          <!-- <div>
        <mat-form-field>
          <mat-select placeholder="{{'Advanced Forecasting' | translate | async}}" [(ngModel)]="selectedForecast" ngDefaultControl>
            <mat-option [value]="forecast.Id" *ngFor="let forecast of forecastingList">
              {{ forecast.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
        </div>
        <div class="step-container">
          <div>
            <button mat-raised-button [disabled]="creatingEquipment" (click)="goBackStep()">{{'Back' | translate | async}}</button>
            <button mat-raised-button *ngIf="newOrExistingOption == '2'" [disabled]="updatingEquipment" [class.loading]="updatingEquipment" (click)="onUpdateEquipmentClick()" color="warn">{{'Update Equipment' | translate | async}}</button>
            <button mat-raised-button *ngIf="newOrExistingOption == '1'" [disabled]="creatingEquipment" [class.loading]="creatingEquipment" (click)="onCreateNewEquipmentClick()" color="warn">{{'Create Equipment' | translate | async}}</button>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
    </div>
  